import { render, staticRenderFns } from "./ActionNote.vue?vue&type=template&id=144615b8&"
import script from "./ActionNote.vue?vue&type=script&lang=js&"
export * from "./ActionNote.vue?vue&type=script&lang=js&"
import style0 from "./ActionNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports